<template>
  <div class="read-status">
    <md-icon
      class="icon-check"
      md-src="/static/images/icon-check.svg"
    />
    <span class="read-text">Lido: {{ formattedDate }}</span>
  </div>
</template>

<script setup>
import { computed } from "vue";
import moment from "moment";

const props = defineProps({
  readAt: {
    type: String,
    required: true,
  },
});

const formattedDate = computed(() => {
  if (!props.readAt || !moment(props.readAt, moment.ISO_8601, true).isValid()) {
    return "";
  }
  return moment.utc(props.readAt).format("DD/MM/YYYY HH:mm");
});
</script>

<style scoped>
.read-status {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #b0b0b0;
}

.icon-check {
  margin-right: 4px;
  color: green;
}

.read-text {
  font-weight: 400;
  color: rgba(0, 0, 0, 0.4);
}
</style>